export const httpPoint = {
    user: '/users/',
    order: '/order/',
    search: '/search/',
}

export const section = [
    'possibilities',
    'services',
    'about'
]









 
